import Dbm from "dbm";
import Website from "../../../index.js";

export default class PhysicsGraphics extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);

        this.item.setValue("x", 0);
        this.item.setValue("y", 0);
        this.item.setValue("followDirection", false);
        this.item.setValue("directionOffset", 1.5*Math.PI);
        this.item.setValue("noGravity", false);
        

        const body = Matter.Bodies.circle(0, 0, 10, {
            label: "graphics",
            isSensor: false,
            isStatic: false,
            collisionFilter: Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.GRAPHICS, Website.game.PhysicsGroups.GRAPHICS_INTERACTIONS)
        });
        
        this.item.setValue("physicsBody", body);
    }

    addSprite(aSprite) {
        this.item.pixiLayer.addChild(aSprite);

        return this;
    }

    setIntialPosition(aCameraPosition) {
        let currentPosition = this.item.physicsBody.position;

        let x = this.item.x - aCameraPosition + Website.game.Sizes.CENTER_X;

        Matter.Body.setPosition(this.item.physicsBody, {
            x: x,
            y: -1*this.item.y
        });

        return this;
    }

    applyForce(aX, aY) {
        Matter.Body.applyForce(this.item.physicsBody, this.item.physicsBody.position, {x: aX, y: -1*aY});

        return this;
    }

    update(aCameraPosition, aTime, aDelta) {
        //console.log("update");

        this.item.pixiLayer.x = this.item.physicsBody.position.x;
        this.item.pixiLayer.y = this.item.physicsBody.position.y+(Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION);
        

        if(this.item.followDirection) {
            const vx = this.item.physicsBody.velocity.x;
            const vy = this.item.physicsBody.velocity.y;

            if (Math.abs(vx)+Math.abs(vy) > 0) {
                this.item.pixiLayer.rotation = Math.atan2(vy, vx)+this.item.directionOffset;
            }
        }
        else {
            this.item.pixiLayer.rotation = this.item.physicsBody.angle;

            /*
            if(this.item.noGravity) {
                const mass = this.item.physicsBody.mass;
                console.log(this.item.physicsBody.velocity.y)
                Matter.Body.setVelocity(this.item.physicsBody, {
                    x: this.item.physicsBody.velocity.x,
                    y: Math.min(this.item.physicsBody.velocity.y, -0.3)
                });
            }
            */
        }
    }

    hasPassed(aCameraPosition) {
        if(this.item.physicsBody.position.y > Website.game.Sizes.HEIGHT) {
            return true;
        }

        return false;
    }
}